export const messages = {
  description: {
    id: 'admin/promotions.form.more-for-less.editor.benefit.description',
  },
  placeholder: {
    id: 'admin/promotions.form.more-for-less.editor.benefit.description.placeholder',
  },
  aria: {
    quantity: {
      id: 'admin/promotions.form.more-for-less.editor.benefit.quantity.aria-label',
    },
    discountValue: {
      id: 'admin/promotions.form.more-for-less.editor.discount-value.aria-label',
    },
    discountType: {
      id: 'admin/promotions.form.more-for-less.editor.discount-type.aria-label',
    },
  },
  quantityPlaceholder: {
    id: 'admin/promotions.form.more-for-less.quantity.placeholder',
  },
  discountOptions: {
    percentual: {
      id: 'admin/promotions.form.more-for-less.editor.benefit.discount.percentual',
    },
    maxPricePerItem: {
      id: 'admin/promotions.form.more-for-less.editor.benefit.discount.max-price-per-item',
    },
  },
  validation: {
    quantityMaxValue: {
      id: 'admin/promotions.form.more-for-less.editor.benefit.quantity.validation',
    },
    minValue: { id: 'admin/promotions.form.validation.greater-than' },
    maxValue: { id: 'admin/promotions.form.validation.less-than-equals' },
  },
}
